import { Tabs as AntTabs } from 'antd';

import AssignmentTab from './assignment';
import CostsTab from './costs';
import DetailsTab from './details';
import PayTab from './pay';
import RatingsTab from './ratings';
import RequestsTab from './requests';

export default function Tabs() {
    return (
        <AntTabs
            items={[
                {
                    label: 'Details',
                    key: 'tab-details',
                    children: <DetailsTab />,
                },
                {
                    label: 'Costs',
                    key: 'tab-costs',
                    children: <CostsTab />,
                },
                {
                    label: 'Assignment',
                    key: 'tab-assignment',
                    children: <AssignmentTab />,
                },
                {
                    label: 'Requests',
                    key: 'tab-requests',
                    children: <RequestsTab />,
                },
                {
                    label: 'Ratings',
                    key: 'tab-ratings',
                    children: <RatingsTab />,
                },
                {
                    label: 'Pay',
                    key: 'tab-pay',
                    children: <PayTab />,
                },
            ]}
        />
    );
}
